import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { Form, Spinner } from 'react-bootstrap'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'
import { message } from 'antd'

import ReviewResultForm from './ReviewResultForm'

import { storeReviewResult } from '../services'
import { handleError } from '../../../helpers'

export default function NewReviewResultModal({ visible, onClose, reload, serviceReview }) {
	const [loading, setLoading] = useState(false)
	const { handleSubmit, register, formState: { errors }, watch } = useForm({
		defaultValues: { service_review_id: serviceReview.id }
	})

	const onSubmit = values => {
		setLoading(true)
		storeReviewResult(values)
			.then(res => {
				message.success(res.data.message)
				reload()
				onClose()
			})
			.catch(error => handleError(error, setLoading))
	}

	return (
		<React.Fragment>
			<Modal isOpen={visible} toggle={onClose}>
				<ModalHeader toggle={onClose}>Registrar resultado del diagnóstico</ModalHeader>
				<ModalBody>
					<Form onSubmit={handleSubmit(onSubmit)}>
						<ReviewResultForm 
							register={register}
							errors={errors}
							watch={watch}
							serviceReview={serviceReview}
						/>
						<Button color='primary' type="submit" disabled={loading}>
							{ loading && <Spinner animation='border' size="sm" className='mr-1' /> }
							Registrar Resultado
						</Button>
					</Form>
				</ModalBody>
			</Modal>
		</React.Fragment>
	)
}